// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MAvahRRKFDNu941QGeK9 {
    width: 100%;
    min-width: 0;
    overflow: hidden;
}
.IrDdfXQXaHoxSpAF8JP3 {
    margin: 0 auto;
    overflow: hidden;
    outline: 1px solid var(--mark-border);
    outline-offset: -1px;
    background: white;
}
.PNxpD7QiQ7sKqAEZ_aw5 {
    display: block;
    max-width: none;
    border: 0;
    background: white;
    transform-origin: top left;
}
`, "",{"version":3,"sources":["webpack://./pages/Mark/components/emailPreviewFrame.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,qCAAqC;IACrC,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,0BAA0B;AAC9B","sourcesContent":[".container {\n    width: 100%;\n    min-width: 0;\n    overflow: hidden;\n}\n.viewport {\n    margin: 0 auto;\n    overflow: hidden;\n    outline: 1px solid var(--mark-border);\n    outline-offset: -1px;\n    background: white;\n}\n.frame {\n    display: block;\n    max-width: none;\n    border: 0;\n    background: white;\n    transform-origin: top left;\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `MAvahRRKFDNu941QGeK9`;
export var viewport = `IrDdfXQXaHoxSpAF8JP3`;
export var frame = `PNxpD7QiQ7sKqAEZ_aw5`;
export default ___CSS_LOADER_EXPORT___;
